(function () {
  'use strict';

  const COUPON_SELECTOR = '.gta-content__coupon.gta-coupon';
  const COUPON_TEXT_CLASS = 'gta-coupon__code-text';
  const TIMER_LABEL_SELECTOR = '.gta-timer__unit-label';
  const PRODUCT_TIMER_SELECTOR = '.product-gsc-timer';
  const BUTTON_CONTAINER_SELECTOR = '.gta-content__button-container';

  const TIMER_LABELS = {
    days: 'DAYS',
    day: 'DAYS',
    hours: 'HRS',
    hour: 'HRS',
    hrs: 'HRS',
    mins: 'MIN',
    min: 'MIN',
    minutes: 'MIN',
    minute: 'MIN',
    secs: 'SEC',
    sec: 'SEC',
    seconds: 'SEC',
    second: 'SEC',
  };

  let isScheduled = false;

  function getElements(root, selector) {
    const elements = [];
    const scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches(selector)) {
      elements.push(scope);
    }

    scope.querySelectorAll(selector).forEach(function (element) {
      elements.push(element);
    });

    return elements;
  }

  function wrapCouponText(root) {
    const coupons = getElements(root, COUPON_SELECTOR);

    coupons.forEach(function (coupon) {
      if (coupon.querySelector('.' + COUPON_TEXT_CLASS)) {
        return;
      }

      const textNode = Array.from(coupon.childNodes).find(function (node) {
        return node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0;
      });

      if (!textNode) {
        return;
      }

      const span = document.createElement('span');
      span.className = COUPON_TEXT_CLASS;
      span.textContent = textNode.textContent.trim();

      coupon.insertBefore(span, textNode);
      textNode.remove();

      coupon.classList.add('gta-coupon--text-wrapped');
    });
  }

  function updateTimerLabels(root) {
    const labels = getElements(root, TIMER_LABEL_SELECTOR);

    labels.forEach(function (label) {
      const currentText = label.textContent.trim().toLowerCase();

      if (!currentText || !TIMER_LABELS[currentText]) {
        return;
      }

      label.textContent = TIMER_LABELS[currentText];
    });
  }

  function getProductTimers(root) {
    const timers = new Set();

    if (!root || root === document) {
      document.querySelectorAll(PRODUCT_TIMER_SELECTOR).forEach(function (timer) {
        timers.add(timer);
      });

      return Array.from(timers);
    }

    if (root.nodeType !== Node.ELEMENT_NODE) {
      return [];
    }

    if (root.matches(PRODUCT_TIMER_SELECTOR)) {
      timers.add(root);
    }

    const closestTimer = root.closest(PRODUCT_TIMER_SELECTOR);

    if (closestTimer) {
      timers.add(closestTimer);
    }

    root.querySelectorAll(PRODUCT_TIMER_SELECTOR).forEach(function (timer) {
      timers.add(timer);
    });

    return Array.from(timers);
  }

  function addProductCloseButton(container, productTimer) {
    if (container.querySelector('.product-gsc-timer__close')) {
      return;
    }

    const closeButton = document.createElement('button');

    closeButton.type = 'button';
    closeButton.className = 'product-gsc-timer__close';
    closeButton.setAttribute('aria-label', 'Close product timer');

    closeButton.addEventListener('click', function () {
      productTimer.style.display = 'none';
    });

    container.prepend(closeButton);
  }

  function prepareProductTimer(root) {
    const productTimers = getProductTimers(root);

    productTimers.forEach(function (productTimer) {
      const container = productTimer.querySelector(
        '.gta-content__container[class*="GSC-SMALL"]'
      );

      const content = productTimer.querySelector(
        '.gta-content[class*="GSC-SMALL"]'
      );

      if (!container || !content) {
        return;
      }

      addProductCloseButton(container, productTimer);

      if (content.dataset.gscPrepared === 'true') {
        return;
      }

      const directChildren = Array.from(content.children);

      const texts = directChildren.filter(function (element) {
        return element.classList.contains('gta-content__text');
      });

      const timerBlock = directChildren.find(function (element) {
        return element.classList.contains('gta-content__timer');
      });

      const coupon = directChildren.find(function (element) {
        return element.matches && element.matches(COUPON_SELECTOR);
      });

      const buttonContainer = directChildren.find(function (element) {
        return element.matches && element.matches(BUTTON_CONTAINER_SELECTOR);
      });

      if (!timerBlock) {
        return;
      }

      if (texts[0]) {
        texts[0].classList.add('gsc-small-title');
      }

      if (texts[1]) {
        texts[1].classList.add('gsc-small-subtitle');
      }

      if (buttonContainer) {
        buttonContainer.classList.add('gsc-small-button-container');
      }

      const layout = document.createElement('div');
      layout.className = 'gsc-small-layout';

      const info = document.createElement('div');
      info.className = 'gsc-small-info';

      layout.appendChild(timerBlock);
      layout.appendChild(info);

      texts.forEach(function (text) {
        info.appendChild(text);
      });

      if (coupon) {
        info.appendChild(coupon);
      }

      if (buttonContainer) {
        info.appendChild(buttonContainer);
      }

      content.appendChild(layout);
      content.dataset.gscPrepared = 'true';
      productTimer.classList.add('product-gsc-timer--ready');
    });
  }

  function processGscTimer(root) {
    wrapCouponText(root);
    updateTimerLabels(root);
    prepareProductTimer(root);
  }

  function scheduleProcess() {
    if (isScheduled) {
      return;
    }

    isScheduled = true;

    window.requestAnimationFrame(function () {
      isScheduled = false;
      processGscTimer(document);
    });
  }

  function initGscTimerObserver() {
    processGscTimer(document);

    const observer = new MutationObserver(function () {
      scheduleProcess();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGscTimerObserver);
  } else {
    initGscTimerObserver();
  }
})();